// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Ouroboros_Models_Brands_Email from "../Ouroboros.Models.Brands.Email/index.js";
import * as Ouroboros_Models_Brands_FirstName from "../Ouroboros.Models.Brands.FirstName/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_LastName from "../Ouroboros.Models.Brands.LastName/index.js";
import * as Ouroboros_Models_Brands_OrganizationName from "../Ouroboros.Models.Brands.OrganizationName/index.js";
import * as Ouroboros_Models_Brands_SubscriptionStatus from "../Ouroboros.Models.Brands.SubscriptionStatus/index.js";
import * as Ouroboros_Models_Documents_Documents from "../Ouroboros.Models.Documents.Documents/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_List_Types.showNonEmptyList(Foreign.showForeignError));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var readJson = function (dictReadForeign) {
    var read = Simple_JSON.read(dictReadForeign);
    return function (value) {
        return lmap(show)(read(value));
    };
};
var readJson1 = /* #__PURE__ */ readJson(/* #__PURE__ */ Simple_JSON.readMaybe(/* #__PURE__ */ Simple_JSON.readRecord()(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "email";
    }
})(Ouroboros_Models_Brands_Email.readEmail)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "expiration";
    }
})(Ouroboros_Models_Brands_IsoTimestamp.readIsoTimestamp)(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "firstName";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_FirstName.readFirstName))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "lastName";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_LastName.readLastName))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "organizationName";
    }
})(/* #__PURE__ */ Simple_JSON.readMaybe(Ouroboros_Models_Brands_OrganizationName.readOrganizationName))(/* #__PURE__ */ Simple_JSON.readFieldsCons({
    reflectSymbol: function () {
        return "status";
    }
})(Ouroboros_Models_Brands_SubscriptionStatus.readSubscriptionStatus)(Simple_JSON.readFieldsNil)()())()())()())()())()())()())));
var isSubscriptionStatus = function (value) {
    return value === "Paid" || (value === "Canceled" || (value === "PaymentFailed" || (value === "FreeTrialMode" || value === "PaymentNotYetConfigured")));
};
var validateAccountResponse = function (response) {
    return Ouroboros_Models_Documents_Documents.isNonEmpty(response.email) && (isSubscriptionStatus(response.status) && Ouroboros_Models_Documents_Documents.isIsoDate(response.expiration));
};
var failWith = function (message) {
    return new Data_Either.Left(message);
};
var decodeAccountResponse = function (value) {
    return bind(readJson1(value))(function (decoded) {
        if (decoded instanceof Data_Maybe.Nothing) {
            return failWith("Invalid account payload");
        };
        if (decoded instanceof Data_Maybe.Just) {
            var $56 = validateAccountResponse(decoded.value0);
            if ($56) {
                return new Data_Either.Right(decoded.value0);
            };
            return failWith("Invalid account payload");
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Clients.Account (line 55, column 3 - line 61, column 43): " + [ decoded.constructor.name ]);
    });
};
export {
    decodeAccountResponse
};
//# sourceMappingURL=index.js.map
